"use client";

import { forwardRef, useState, type InputHTMLAttributes } from "react";
import { FloatingInput } from "./floating-input";

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  error?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, value, ...props }, ref) => {
    const [visible, setVisible] = useState(false);
    const hasValue = value !== undefined && value !== null && value !== "";
    const mergedClassName = `pr-11 ${className ?? ""}`.trim();

    return (
      <div className="relative">
        <FloatingInput
          ref={ref}
          {...props}
          value={value}
          type={visible ? "text" : "password"}
          className={mergedClassName}
        />
        {hasValue && (
          <button
            type="button"
            onClick={() => setVisible((v) => !v)}
            aria-label={visible ? "Hide password" : "Show password"}
            aria-pressed={visible}
            className="absolute top-0 right-0 h-full w-11 flex items-center justify-center text-[var(--color-gray-400)] hover:text-[var(--color-gray-600)] focus:outline-none focus-visible:text-[var(--color-accent)] focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] rounded-[var(--radius-lg)] cursor-pointer"
          >
            {visible ? (
              <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            ) : (
              <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            )}
          </button>
        )}
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";
